import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCloudRain} from "@fortawesome/free-solid-svg-icons";

import {LIVE_FORECAST_SOURCE_TITLE} from "../utils/weather-links.js";
import {slugify} from "../utils/helpers.js";

import {AnchorInline, Small, Text} from "../style/components/general";
import {flex} from "../style/components/mixins";
import {pad, radius} from "../style/components/variables";
import {voice} from "../style/components/typography";

const PrecipitationChanceIndicator = ({precipitationChance, links = []}) => {
  if (precipitationChance == null) return null;

  return (
    <Block data-testid="precipitation-chance-indicator">
      <Wrapper>
        <FontAwesomeIcon icon={faCloudRain} />
        <Text>{Math.round(precipitationChance)}% chance</Text>
      </Wrapper>
      {links.length > 0 && (
        <SourceLinks>
          <Small secondary>Source:&nbsp;</Small>
          {links.map(({label, url}, index) => (
            <React.Fragment key={label}>
              {index > 0 && <Small secondary>,&nbsp;</Small>}
              <SourceLink
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                title={LIVE_FORECAST_SOURCE_TITLE}
                data-testid={`weather-source-${slugify(label)}`}>
                {label} ↗
              </SourceLink>
            </React.Fragment>
          ))}
        </SourceLinks>
      )}
    </Block>
  );
};

PrecipitationChanceIndicator.propTypes = {
  precipitationChance: PropTypes.number,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      provider: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired
    })
  )
};

const Block = styled.div`
  margin-top: ${pad * 2}px;
  margin-bottom: ${pad}px;
  width: fit-content;
`;

const Wrapper = styled.div`
  ${flex("row", "nowrap", "start", "center")};
  ${voice.small};
  gap: ${pad / 2}px;
  padding: ${pad / 2}px ${pad}px;
  border: 2px solid ${({theme}) => theme.secondary};
  border-radius: ${radius};
  color: ${({theme}) => theme.primary};
  font-weight: bold;

  svg {
    color: ${({theme}) => theme.secondary};
  }
`;

const SourceLinks = styled.div`
  ${flex("row", "wrap", "start", "center")};
  margin-top: ${pad / 2}px;
`;

const SourceLink = styled(AnchorInline)`
  ${voice.quiet};
`;

export default PrecipitationChanceIndicator;
